import { getGreeting } from "../../utils/getGreeting";
import { useGetEmployeeMeQuery } from "../../../../common/api/employee";
import Skeleton from "react-loading-skeleton";
import { JSX } from "react";
import { getUserFullName } from "../../../../common/utils/getUserFullName";

export const DashboardHeader = (): JSX.Element | null => {
    const { data: employeeData, isLoading: employeeDataIsloading } =
        useGetEmployeeMeQuery({});

    if (employeeDataIsloading) {
        return <Skeleton height={"5rem"} count={2} borderRadius={"1.5rem"} />;
    }

    if (!employeeData) {
        return null;
    }

    return (
        <section className="p-dashboard__header">
            <div className="c-breadcrumbs">
                <span>Dashboards / LMS</span>
            </div>
            <h1>
                {getGreeting()}, {getUserFullName(employeeData.user)}
            </h1>
        </section>
    );
};
